export default __webpack_public_path__ + "static/media/asset1.08f69826.png";